/*
 * Ce fichier répertorie des fonctions utilitaires (array, string, number, ...)
 * et standardise le prototype de certains objets JavaScript ("polyfills").
 * Elle contient également des fonctions liées à certaines bibliothèques
 * optionnelles (jquery, ckeditor, ...) ou certains pattern de code (buildElement, aggregate, search).
 */
window.BaseAPI = (function(jQuery) {
"use strict";

var polyfills = [];

function polyfill(object, property, value) {
	// On enregistre la méthode pour les tests (vérifier que le comportement existant ou notre comportement est conforme)  
	polyfills.push({ object: object, property: property});
	// Surcharger la propriété si elle n'est pas implémentée
	if (! object[property])
		object[property] = value;
}

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill */
polyfill(Array.prototype, 'fill', function arrayFill(value, start, end) {
	var length = this.length;
	var s = start === undefined ? 0 : start;
	var e = end === undefined ? length : end;
	s = s < 0 ? Math.max(length + s, 0) : Math.min(s, length);
	e = e < 0 ? Math.max(length + e, 0) : Math.min(e, length);
	for (var i = s; i < e; i++) {
		this[i] = value;
	}
	return this;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find */
polyfill(Array.prototype, 'find', function arrayFind(callback, thisArg) {
	for (var i = 0; i < this.length; i++) {
		if (callback.call(thisArg, this[i], i, this))
			return this[i];
	}
	return undefined;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast */
polyfill(Array.prototype, 'findLast', function arrayFindLast(callback, thisArg) {
	for (var i = this.length - 1; i >= 0; i--) {
		if (callback.call(thisArg, this[i], i, this))
			return this[i];
	}
	return undefined;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex */ 
polyfill(Array.prototype, 'findIndex', function arrayFindIndex(callback, thisArg) {
	for (var i = 0; i < this.length; i++) {
		if (callback.call(thisArg, this[i], i, this))
			return i;
	}
	return -1;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes */
polyfill(Array.prototype, 'includes', function arrayIncludes(searchElement, fromIndex) {
	// Cas particulier pour NaN, qui a la particularité de ne pas être égal à lui-même
	// La spec indique qu'on doit retourner true pour NaN aussi. Or, indexOf ne fonctionne pas. 
	if (searchElement !== searchElement)
		return this.slice(fromIndex).some(function(e) { return e !== e; });
	return this.indexOf(searchElement, fromIndex) >= 0;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith */
polyfill(String.prototype, 'startsWith', function stringStartsWith(searchString, position) {
	position = position || 0;
	return this.substr(position, searchString.length) === searchString;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith */
polyfill(String.prototype, 'endsWith', function stringEndsWith(searchString, position) {
	var subjectString = this.toString();
	if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length)
		position = subjectString.length;
	position -= searchString.length;
	var lastIndex = subjectString.indexOf(searchString, position);
	return lastIndex !== -1 && lastIndex === position;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes */
polyfill(String.prototype, 'includes', function stringIncludes(searchString, position) {
	position = position || 0;
	return this.indexOf(searchString, position) !== -1;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat */
polyfill(String.prototype, 'repeat', function stringRepeat(count) {
	count = Math.floor(count || 0);
	if (count < 0)
		throw new RangeError('repeat count must be non-negative');
	if (count === Infinity)
		throw new RangeError('repeat count must be less than infinity');
	if (this.length * count >= 1 << 28)
		throw new RangeError('repeat count must not overflow maximum string size');
	if (this.length === 0 || count === 0)
		return '';
	var str = '' + this;
	var rpt = '';
	for (;;) {
		if ((count & 1) === 1) rpt += str;
		count >>>= 1;
		if (count === 0)
			break;
		str += str;
	}
	return rpt;
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/TrimLeft */
polyfill(String.prototype, 'trimLeft', function stringTrimLeft() {
	return this.replace(/^[\s\uFEFF\xA0]+/g, '');
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/TrimRight */
polyfill(String.prototype, 'trimRight', function stringTrimRIght() {
	return this.replace(/[\s\uFEFF\xA0]+$/g, '');
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN */
polyfill(Number, 'isNaN', function numberIsNaN(value) {
	return typeof value === 'number' && isNaN(value);
});

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseInt */
polyfill(Number, 'parseInt', parseInt);

/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseFloat */
polyfill(Number, 'parseFloat', parseFloat);

/**
 * Cette méthode permet de rechercher une entrée en particulier dans un tableau (supposé trié) en utilisant la recherche dichotomique.
 * La fonction de callback prend 2 paramètres (item, index) et retourne :
 * - soit -1 pour indiquer de continuer la recherche dans la première moitié
 * - soit 1 pour indiquer de continuer la recherche dans la seconde moitié
 * - soit 0 pour indiquer qu'on a trouvé ce qu'on cherche et que l'on peut s'arrêter
 *
 * @see https://fr.wikipedia.org/wiki/Recherche_dichotomique
 * @param {Array} array - le tableau dans lequel effectuer la recherche
 * @param {Function} callback - une fonction (item, index)-> (-1|1|0) indiquant si et comment on doit continuer la recherche
 * @return true si l'élément a été trouvé (callback retourne 0) ou false s'il n'a pas été trouvé (arrête sur maxIndex / minIndex)
 */
function arrayDichotomique(array, callback) {
	var minIndex = 0, // borne min (incluse) de l'intervalle en cours
		maxIndex = array.length, // borne max (excluse) de l'intervalle en cours
		index, // index de l'élément testé dans la boucle, au milieu de l'intervalle en cours
		result; // résultat de la callback pour l'élément en cours (<0:gauche, 0:stop, >0:droite)
	while (minIndex !== maxIndex) {
		index = Math.floor((minIndex + maxIndex) / 2);
		result = callback(array[index], index);
		if (result < 0) {
			// continuer la recherche sur la moitié gauche
			if (maxIndex !== index)
				maxIndex = index;
			else
				return false;
		} else if (result > 0) {
			// continuer la recherche sur la moitié droite
			if (minIndex !== index)
				minIndex = index;
			else
				return false;
		} else {
			// arrêter la recherche
			return true;
		}
	}
}

/**
 * Cette fonction supprime d'un tableau toutes les occurences d'un élément.
 * 
 * @param {Array} array - le tableau dans lequel on supprimer la recherche
 * @param {Any} item - l'élément à retirer du tableau
 * @return {Number} le nombre d'occurence retirées du tableau
 * @see Array.prototype.indexOf et Array.prototype.splice
 */
function arrayRemove(array, item) {
	var index = array.indexOf(item), count = 0;
	while (index >= 0) {
		array.splice(index, 1);
		count++;
		index = array.indexOf(item, index);
	}
	return count;
}

/**
 * Cette méthode retourne l'extension 'txt', 'zip', ... correspondant au nom de fichier représenté par la chaine de caractères.
 * @return l'extension (txt, zip, ...) correspondant au nom de fichier ou '' si le nom de fichier n'a pas d'extension
 */
function stringFileExtension(filename) {
	var i = filename.lastIndexOf('.');
	return (i === -1) ? '' : filename.substring(i + 1);
}

/**
 * Cette méthode convertit la chaine de caractère en un flottant en utilisant parseFloat().
 * Si la chaine est vide ou ne peut être convertie en flottant, la méthode retourne la valeur par défaut (si elle précisée) ou undefined (sinon).
 * @see String.prototype.parseInt
 * @param {Float} defaultValue - le flottant par défaut si la chaine ne peut être convertie
 * @return {Float} le flottant issu de la chaine ou la valeur par défaut si la chaine ne peut être convertie
 */
function stringParseFloatSafe(s, defaultValue) {
	if (s.length > 0)
		try {
			var r = parseFloat(s);
			if (!Number.isNaN(r))
				return r;
		} catch (e) {}
	return defaultValue;
}

/**
 * Cette méthode convertit la chaine de caractère en un entier en utilisant parseInt().
 * Si la chaine est vide ou ne peut être convertie en entier, la méthode retourne la valeur par défaut (si elle précisée) ou undefined (sinon). 
 * @see String.prototype.parseFloat
 * @param {Int} defaultValue - l'entier par défaut si la chaine ne peut être convertie
 * @return {Int} l'entier issu de la chaine ou la valeur par défaut si la chaine ne peut être convertie
 */
function stringParseIntSafe(s, defaultValue) {
	if (s.length > 0)
		try {
			var r = parseInt(s);
			if (!Number.isNaN(r))
				return r;
		} catch (e) {
		}
	return defaultValue;
}

/**
 * Cette méthode vérifie si le nombre est dans l'intervalle, éventuellement ouvert, compris entre "min" et "max".
 * 
 * @param {Number} n - le nombre à tester
 * @param {Number} min - le début de l'intervalle. Si non précisé, l'intervalle est ouvert et "min" est donc interprété comme Number.NEGATIVE_INFINITY
 * @param {Number} max - la fin de l'intervalle. Si non précisé, l'intervalle est ouvert et "max" est donc interprété comme Number.POSITIVE_INFINITY
 * @param {Boolean} strictly - indique si les borne "min" et "max" elles-même sont exclues de l'intervalle (cad [min, max] ou ]min, max[)
 * @return {Boolean} true si le nombre est dans l'intervalle, false sinon
 */
function numberBetween(n, min, max, strictly) {
	min = min || Number.NEGATIVE_INFINITY;
	max = max || Number.POSITIVE_INFINITY;
	return (!!strictly) ? (n > min && n < max) : (n >= min && n <= max);
}

/**
 * Cette méthode formatte le nombre tel que demandé
 * 
 * @param {Number} n - le nombre à formatter
 * @param {Number} decimals - le nombre de chiffre après la virgule, 0 par défaut.
 * @param {String} decimalSeparator - le séparateur décimal, '.' par défaut.
 * @param {String} thousandSeparator - le séparateur de milliers, '' par défaut.
 */
function numberFormatFromParameters(n, decimals, decimalSeparator, thousandSeparator) {
	if (isNaN(n))
		return '';
	// Exemple BaseAPI.numberFormatFromParameters(1234560.789, 2, ',', ' ') => '1 234 560,79'
	decimals = decimals || 0;
	decimalSeparator = decimalSeparator || '.';
	thousandSeparator = thousandSeparator || '';
	var negative = n < 0;
	var result = Math.abs(Math.round(n * Math.pow(10, decimals))).toString(); // 123456079
	if (result.length < decimals) {
		while (result.length < decimals) {
			result = '0' + result;
		}
	}

	var i = result.length - decimals - 3; // 4
	while (i > 0) {
		result = result.substring(0,i) + thousandSeparator + result.substring(i); // 1234 56079 then 1 234 56079
		i -= 3; // 1 then -2
	}
	var intPart = result.substring(0, result.length - decimals); // 1 234 560
	var floatPart = (decimals > 0) ? (decimalSeparator + result.substring(result.length - decimals)) : ''; // ,79
	return (negative ? '-' : '') + (intPart || '0') + floatPart; // 1 234 560,79
}

/**
 * Cette méthode formatte le nombre en français en fonction de la langue.
 * 
 * @param {Number} n - le nombre à formatter
 * @param {Number} decimals - le nombre de chiffre après la virgule, 0 par défaut.
 * @param {String} locale - la langue, qui peut être 'fr', 'de' ou 'en', par défaut.
 */
function numberFormatFromLocale(n, decimals, locale) {
	if ('fr' === locale)
		return numberFormatFromParameters(n, decimals, ',', ' ');
	if ('de' === locale)
		return numberFormatFromParameters(n, decimals, ',', '.');
	return numberFormatFromParameters(n, decimals, '.', ',');
}

/**
 * Cette méthode parse un nombre en fonction des séparateurs d'une langue
 *
 * @param {Number} decimals - nombre de decimales à appliquer. Si 0 on utilise "parseInt" sinon "parseFloat" au final
 * @param {String} decimalSeparator - le séparateur décimal, '.' par défaut.
 * @param {String} thousandSeparator - le séparateur de milliers, '' par défaut.
 */
function numberParseFromParameters(text, decimals, decimalSeparator, thousandSeparator) {
	if (! text)
		return null;

	// Exemple BaseAPI.numberParseFromParameters("1 234 560,79", true, ",", " ");
	decimalSeparator = decimalSeparator || '.';
	thousandSeparator = thousandSeparator || '';

	// Suppression _des_ espaces (aussi séparateur de millier en 'fr')
	text = text.replace(/\s/g, ''); // 1234560,79

	// Suppression _des_ séparateurs de millier
	if (thousandSeparator === '.')
		text = text.replace(/\./g, ''); // 1234560,79
	else if (thousandSeparator === ',')
		text = text.replace(/,/g, ''); // 1234560,79

	// Remplacement _du_ séparateur décimal
	if (decimalSeparator !== '.')
		text = text.replace(decimalSeparator, '.'); // 1234560.79
	return decimals ? Number.parseFloat(Number.parseFloat(text).toFixed(decimals)) : Number.parseInt(text);
}

/**
 * Cette méthode parse un nombre en fonction d'une langue
 *
 * @param {String} text - texte à parser pour y trouver un nombre
 * @param {Number} decimals - nombre de decimales à appliquer. Si 0 on utilise "parseInt" sinon "parseFloat" au final
 * @param {String} locale - la langue, qui peut être 'fr', 'de' ou 'en', par défaut.
 */
function numberParseFromLocale(text, decimals, locale) {
	if ('fr' === locale)
		return numberParseFromParameters(text, decimals, ',', ' ');
	if ('de' === locale)
		return numberParseFromParameters(text, decimals, ',', '.');
	return numberParseFromParameters(text, decimals, '.', ',');
}

/**
 * La fonction suivante renvoie un aggrégateur générique, auquel on ajoutera des valeurs par
 * "add" ou "addAll" avant d'obtenir une ou plusieurs aggréations grâce aux méthodes "get*".
 * 
 * Exemple :
 * var a = BaseAPI.aggregate(true);
 * a.add(1);
 * a.addAll([2, null, 2, 3]);
 * console.log(a.get());
 * # { min: 1, max: 3, sum: 8, avg: 2, count: 4, distinctsum: 6, distinctavg: 2, distinctcount: 3, repeated: null, rowcount: 5 }
 * 
 * @param {boolean} distinct - active le comportement nécessaire pour les méthodes "getDistinct*"
 * @param {CompareFunction} compare - une fonction facultative de comparaison (par exemple pour définir un epsilon)
 */
function aggregate(distinct, compare) {
	var s = { min: null, max: null, sum: 0, count: 0, rowCount: 0, distinct: [] };
	compare = compare || function(a, b) {
		return (a < b) ? -1 : (a > b) ? 1 : 0;
	};
	function addDistinct(value) {
		var add = (value != null) && !s.distinct.some(function(v) {
			return compare(v, value) === 0;
		});
		if (add)
			s.distinct.push(value);
	}
	return {
		add: function(value) {
			if (value !== null) {
				if (s.min === null || (s.min > value)) s.min = value;
				if (s.max === null || (s.max < value)) s.max = value;
				s.sum += value;
				s.count++;
				if (distinct) addDistinct(value);
			}
			s.rowCount++;
			return this;
		},
		addAll: function(values) {
			values.forEach(this.add.bind(this));
			return this;
		},
		getMin: function() { return s.min; },
		getMax: function() { return s.max; },
		getSum: function() { return s.sum; },
		getAvg: function() { return s.count === 0 ? null : (s.sum / s.count); },
		getCount: function() { return s.count; },
		getDistinctSum: function() { return aggregate(false, compare).addAll(s.distinct).getSum(); },
		getDistinctAvg: function() { return aggregate(false, compare).addAll(s.distinct).getAvg(); },
		getDistinctCount: function() { return aggregate(false, compare).addAll(s.distinct).getCount(); },
		getRepeated: function() { return compare(s.min, s.max) === 0 ? s.min : null; },
		getRowCount: function() { return s.rowCount; },
		get: function() {
			var r = {};
			r.min = s.min;
			r.max = s.max;
			r.sum = s.sum;
			r.avg = s.count === 0 ? null : (s.sum / s.count);
			r.count = s.count;
			if (distinct) {
				var rTemp = aggregate(false, compare).addAll(s.distinct);
				r.distinctsum = rTemp.getSum();
				r.distinctavg = rTemp.getAvg();
				r.distinctcount = rTemp.getCount();
			}
			r.repeated = compare(s.min, s.max) === 0 ? s.min : null;
			r.rowcount = s.rowCount;
			return r;			
		}
	};
}

/**
 * Cette fonction renvoie un objet facilitant le traitement d'une recherche textuelle :
 * - sa méthode 'prepare(string):string' simplifie le texte pour rendre la recherche plus souple pour l'utilisateur
 * - sa méthode 'build(string):object' renvoie un nouvel objet pour tester selon un texte recherché
 * - la méthode 'matches(string):boolean' de ce nouvel objet teste la correspondance d'un texte à la recherche 
 * 
 * Les plus attentifs verront que le traitement se fait en 3 étapes :
 * - la 1ère est l'appel à 'BaseAPI.search()'. L'idée est d'obtenir un objet configurable à moyen terme (mais pas pour le moment non)
 * - la 2ème est l'appel à 'builder.build(searchText)'. L'analyse du texte recherché ne sera faite qu'une fois, même si on a plusieurs comparaisons à faire.
 * - la 3ème est l'appel à 'search.matches(otherText)'. Cet appel pourra être fait plusieurs fois, de manière optimale, pour chaque texte à vérifier
 *
 * La recherche s'effectue actuellement en appliquant les simplifications suivantes aux textes manipulés :
 * - passe le texte en minuscules pour une recherche insensible à la casse
 * - y remplace les caractères accentués par l'équivalent sans accent, y compris le 'ç', pour une recherche insensible aux accents
 * - y remplace 'æ' par 'ae', 'œ' par 'oe' et 'ß' par 'ss'
 * - y remplace '-' par ' ' et '\'' par ' '
 *
 * ```js
 * Exemple :
 * var builder = BaseAPI.search();             // { prepare: ..., build: ... }
 * console.log(builder.prepare('mini-Icône')); // 'mini icone'
 *
 * var search = builder.build('icon');        // { matches: ... }
 * console.log(search.matches('Icône'));     // true
 * ```
 *
 * Un peu de lecture
 * - https://www.developpez.net/forums/d1134410/javascript/general-javascript/fonction-remplacer-caracteres-accentues/
 * - http://www.vingtseptpointsept.fr/2011/09/22/une-fonction-javascript-pour-eliminer-accents-et-diacritiques/
 *
 * @param {string} text - le texte recherché, qui sera ensuite testé selon un ou plusieurs textes en appelant "matches"
 * @returns {object} un objet avec une méthode "matches(string):boolean"
 */
function search() {
	var replacements = { à:'a',â:'a',ä:'a',æ:'ae',ç:'c',é:'e',è:'e',ê:'e',ë:'e',î:'i',ï:'i',ô:'o',ö:'o',œ:'oe',ß:'ss',ù:'u',û:'u',ü:'u','-': ' ','\'': ' ' };
	function prepare(text) {
		if (typeof text !== 'string')
			throw new Error('Utilisation incorrecte');
		var r = '', s = text.toLowerCase(), c, i;
		for (i = 0; i < s.length; i++) {
			c = replacements[s[i]];
			r += (typeof c !== 'undefined') ? c : s[i];
		}
		return r;
	}
	return {
		prepare: prepare,
		build: function build(text) {
			var cleanText = prepare(text);
			return {
				matches: function matches(otherText) {
					return prepare(otherText).indexOf(cleanText) >= 0;
				}
			};
		}
	};
}

/**
 * Cette méthode calcule la taille des scrollbars natives qui apparaissent quand on élément peut scroller.
 * Quelques exemples de variation de taille vérifiée ce jour (16/10/2018) :
 * - Chrome 69 (DPR 125%, zoom 100%)   : 16.8 pixels
 * - Chrome 69 (DPR 125%, zoom 90%)    : 18.666 pixels
 * - Chrome 69 (DPR 100%, zoom 100%)   : 17 pixels
 * - Chrome 69 (DPR 100%, zoom 90%)    : 18.888 pixels
 * - Edge 17 (DPR indif., zoom indif.) : 16 pixels
 * - IE 11 (DPR indif. zoom indof.)    : 17 pixels
 * - Firefox 62 (DPR 125%, zoom 100%)  : 16.8 pixels
 * - Firefox 62 (idem, vue adaptative) : 0 pixel
 * - Firefox 62 (DPR 100%, zoom 100%)  : 17 pixels
 * - Firefox 62 (DPR 100%, zoom 90%)   : 18.9833 pixels
 * - Firefox 62 (idem, vue adaptative) : 0 pixel
 */
function getScrollDimensions(body) {
	var outerDiv = jQuery('<div style="position:absolute; left:-999px; top:-999px; width: 60px; height: 60px; overflow: scroll; " />').appendTo(body); 
	var innerDiv = jQuery('<div style="display: block; width: 100%; height: 100%; " />').appendTo(outerDiv);
	// console.log(outerDiv.width(), outerDiv.innerWidth(), outerDiv.outerWidth(), innerDiv.width(), innerDiv.innerWidth(), innerDiv.outerWidth());
	var width = outerDiv.innerWidth() - innerDiv.outerWidth();
	var height = outerDiv.innerHeight() - innerDiv.outerHeight();
	// console.log(width, height, window.devicePixelRatio);
	outerDiv.remove();
	return {
		width: width,
		height: height
	};
}

/**
 * La fonction suivante n'est pas vraiment un polyfill mais une fonction de bas niveau qui sera utilisée un peu partout.
 * Elle fournit un objet ressemblant à jQuery, en beaucoup plus rapide mais limité à la création d'élément DOM.
 */
function buildElement(tag) {
	var e = document.createElement(tag);
	return {
		prop: function(name, value) { e[name] = value; return this; },
		attr: function(name, value) { e.setAttribute(name, value); return this; },
		rowspan: function(rowspan) { if (rowspan && rowspan >= 2) e.setAttribute('rowspan', rowspan); return this; },
		colspan: function(colspan) { if (colspan && colspan >= 2) e.setAttribute('colspan', colspan); return this; },
		css: function(name, value) { e.style[name] = value; return this; },
		data: function(name, value) { jQuery(e).data(name, value); return this; },
		empty: function() { e.textContent = ''; return this; },
		addClass: function(cssClass) { cssClass.split(' ').forEach(function(c) { e.classList.add(c); }); return this; },
		removeClass: function(cssClass) { cssClass.split(' ').forEach(function(c) { e.classList.remove(c); }); return this; },
		toggleClass: function(cssClass, present) { /*IE ne supporte pas le paramètre booléen*/ var cl = e.classList; if (typeof present === 'undefined') cl.toggle(cssClass); else if (present) cl.add(cssClass); else cl.remove(cssClass); return this; },
		text: function(text) { e.textContent = text; return this; },
		html: function(html) { e.innerHTML = html; return this; },
		append: function(dom) { if (dom) e.appendChild(dom.toDOM ? dom.toDOM() : dom); return this; },
		prepend: function(dom) { if (dom) e.insertBefore(dom.toDOM ? dom.toDOM() : dom, e.childNodes[0]); return this; },
		appendTo: function(dom) { if (dom.toDOM) dom.append(e); else dom.appendChild(e); return this; },
		prependTo: function(dom) { if (dom.toDOM) dom.prepend(e); else dom.insertBefore(e, dom.childNodes[0]); return this; },
		on: function(event, listener) { e.addEventListener(event, listener); return this; },
		toDOM: function() { return e; },
		toJQUERY: function() { return jQuery(e); }
	};
}

/**
 * Cette fonction enregistre un plugin jQuery nommé "name" et pouvant être appelée de 3 manières :
 * - $(...).xxx({...}) pour créer le plugin avec les options données
 * - $(...).xxx() pour récupérer l'object "Constructor" précédemment associé
 * - $(...).xxx('destroy') pour détruire le composant jQuery précédemment créé 
 */
function registerJQueryPlugin(name, Constructor) {
	// Composant en jQuery, proposant 3 appels possibles
	jQuery.fn[name] = function(params) {
		// 1. Destruction avec .xxx('destroy');
		if (params === 'destroy') {
			return this.each(function() {
				var self = jQuery(this), component = self.data(name);
				if (component) {
					component.destroy();
					self.removeData(name);
				}
			});
		}

		// 2. Récupération avec .xxx();
		if (typeof params === 'undefined') {
			return this.data(name);
		}

		// 3. Création avec .xxx(params);
		return this.each(function() {
			jQuery(this).data(name, new Constructor(this, params));
		});
	};
}


/*
 * C'est une extension de la gestion des évènements par jQuery.
 * https://learn.jquery.com/events/event-extensions/
 * L'idée est de générer un évènement équivalent au 'dblclick' mais qui marcherait sur Safari
 * Exemples:
 * img.on('dbltap', function() { ... });
 * img.on('dbltap', { threshold: 1000 }, function() { ... });
 * div.on('dbltap', 'img', function() { ... });
 * ...
 */
if (jQuery)
	jQuery.event.special.dbltap = {
		delegateType: 'click',
		bindType: 'click',
		threshold: 500, // nombre de ms max par défaut entre 2 clics pour déclencher le dbltap
		handle: function(event) {
			var handleObj = event.handleObj;
			var targetData = jQuery.data(event.target);
			var ret = null;
			var last = (targetData.last || 0);
			var now = Date.now();
			var threshold = (event.data && event.data.threshold) || jQuery.event.special.dbltap.threshold;
			if (now - last > threshold)
				targetData.last = now;
			else {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply(this, arguments);
				event.type = handleObj.type;
				return ret;
			}
		}
	};
	
	var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
	jQuery.htmlPrefilter = function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	};

/**
 * Cette méthode personnalise CKEditor pour les différentes applications B&B Market, notamment le bouton "Plus..."
 * 
 * @param {String} moreLabel : le libellé du bouton du plugin ShowMore, par défaut "Plus..."
 */
function ckeditorInit(moreLabel) {
	// Récupération de l'API de CKEditor
	var CKEDITOR = window.CKEDITOR;

	// Ajout d'un plugin maison "ShowMore" qui cache les options avancées au départ et
	// permet leur affichage/masquage à volonté via un bouton "Plus...".
	CKEDITOR.plugins.add('bbmarket', {
		init: function(editor) {
			editor.addCommand('ShowMore', {
				modes: {
					wysiwyg: 1,
					source: 1
				},
				readOnly: 1,
				// Si on souhaitait que le bouton soit enfoncé par défaut
				// state: CKEDITOR.TRISTATE_ON,
				exec: function(editor) {
					var container = jQuery(editor.container.$);
					var button = container.find('.cke_button__showmore');
					this.toggleState();
					button.closest('.cke_toolbar').nextAll().toggle();
				}
			});
			editor.ui.addButton('ShowMore', {
				// icon: '../../plugins/ckeditor-more.png',
				label: moreLabel || 'Plus...',
				command: 'ShowMore'
			});
		}
	});
}

/**
 * Cette méthode active l'éditeur riche CKEDITOR sur la textarea référencée par "target".
 * 
 *  @param {String|textarea} target : une textarea ou son nom ou son id, utilisé pour CKEDITOR.replace
 *  @param {boolean} flex : active si demandé l'alignement en flex de l'éditeur pour maximiser la zone de saisie dans son parent
 *  @param {Object} config : un objet pour personnaliser la configuration de l'éditeur à créer
 */
function ckeditorCreate(target, flex, config) {
	// Récupération de l'API de CKEditor
	var CKEDITOR = window.CKEDITOR;

	// Préparation de la configuration par défaut, personnalisables avec "config"
	var defaultConfig = {
		resize_enabled: !flex,
		readOnly: false,
		enterMode: CKEDITOR.ENTER_BR,
		shiftEnterMode: CKEDITOR.ENTER_P,
		tabSpaces: 4,
		disableNativeSpellChecker: false,
		font_names: 'Arial;Times New Roman;Courier New',
		fontSize_sizes: '8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;36/36pt;48/48pt;72/72pt',
		baseFloatZIndex: 30000,
		magicline_color: '#444444',
		// Intégration du plugin "bbmarket" défini dans "ckeditorInit", pour le bouton "Plus..." par exemple
		extraPlugins: 'bbmarket',
		// Désactivation de "scayt" et "wsc" car même après suppression du dossier des plugins, des requêtes partent quand même
		// Désactivation de "elementspath" pour ne pas afficher en bas de l'éditeur le chemin DOM de l'élément en cours
		removePlugins: 'scayt,wsc,elementspath',
		// Ne filtre plus le texte afin de conserver le formattage (surlignage en jaune par exemple)
		allowedContent: true,
		pasteFromWordRemoveFontStyles: false,
		pasteFromWordRemoveStyles: false,
		pasteFromWordPromptCleanup: false,
		toolbar: [
			{ name: 'font', items: ['Font', 'FontSize', 'Bold', 'Italic', 'Underline', 'Strike']},
			{ name: 'justify', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight']},
			{ name: 'colors', items: ['TextColor', 'BGColor']},
			{ name: 'more', items: ['ShowMore']},
			'/', // force le passage à la ligne pour le reste de la barre d'outil et corrige ainsi l'alignement bizarre dans le popin
			{ name: 'text', items: ['BulletedList', 'NumberedList', 'Outdent', 'Indent', 'Blockquote', 'Subscript', 'Superscript']},
			{ name: 'insert', items: ['Link', 'Unlink', /*'Image' images gérées en PJ,*/ 'Table', 'HorizontalRule', 'SpecialChar']},
			{ name: 'tools', items: ['RemoveFormat', 'Maximize', 'Print', 'Source']},
		]
	};

	/// Création de l'éditeur
	var editor = CKEDITOR.replace(target, jQuery.extend({}, defaultConfig, config));

	// Ajustement en "flex" du style de l'éditeur, si demandé (barre d'outil et pied en fixe, la zone de saisie en taille maximale
	if (flex) {
		editor.on('loaded', function(evt) {
			// evt.editor.container.$.style.height = '100%';
			var container = jQuery(evt.editor.container.$).css('height', '100%');
			var layout = container.children('.cke_inner').css({
				'display': 'flex',
				'flex-direction': 'column',
				'height': '100%'
			});
			layout.children('.cke_top, .cke_bottom').css('flex', '0 0 auto');
			layout.children('.cke_contents').css('flex', '1 1 auto');
		});
		editor.on('maximize', function(evt) {
			var container = jQuery(evt.editor.container.$);
			var isMaximized = evt.data === CKEDITOR.TRISTATE_ON/*1*/;
			container.children('.cke_inner').css('display', isMaximized ? 'block' : 'flex');
		});
	}

	// Ajustement de la barre d'outils afin de cacher par défaut les boutons secondaires,
	// quand la barre est prête (loaded) avant l'affichage (instanceReady) pour éviter un clignotement
	editor.on('loaded', function(evt) {
		var container = jQuery(evt.editor.container.$);
		var button = container.find('.cke_button__showmore');
		button.closest('.cke_toolbar').nextAll().hide();
	});
	return editor;
}

// Renvoyer l'API publique pour BaseAPI
return {
	polyfills: polyfills,
	arrayDichotomique: arrayDichotomique,
	arrayRemove: arrayRemove,
	stringFileExtension: stringFileExtension,
	stringParseFloatSafe: stringParseFloatSafe,
	stringParseIntSafe: stringParseIntSafe,
	numberBetween: numberBetween,
	numberFormatFromParameters: numberFormatFromParameters,
	numberFormatFromLocale: numberFormatFromLocale,
	numberParseFromParameters: numberParseFromParameters,
	numberParseFromLocale: numberParseFromLocale,
	aggregate: aggregate,
	search: search,
	getScrollDimensions: getScrollDimensions,
	buildElement: buildElement,
	registerJQueryPlugin: registerJQueryPlugin,
	ckeditorInit: ckeditorInit,
	ckeditorCreate: ckeditorCreate
};

})(window.jQuery);
